<template>
  <div class="ivu-row-flex-end ivu-row-flex" style="margin-left: -12px;margin-right: -12px;">
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="客户名称">
            <Input v-model="formItem.Customer" placeholder="请输入客户名称"></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="物料编码">
            <Input v-model="formItem.materiel_code" placeholder="请输入物料编码"></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="物料名称">
            <Input v-model="formItem.materiel_name" placeholder="请输入物料名称"></Input>
      </FormItem>
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" label-colon
          class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem :label-width="80" label="大类">
            <Input v-model="formItem.material_category" placeholder="请输入物料大类"></Input>
      </FormItem>
    </Form>
     <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <!-- <FormItem :label-width="80" label="物料编码">
            <Input v-model="formItem.materiel_code" placeholder="请输入物料编码"></Input>
      </FormItem> -->
    </Form>
    <Form style="padding-left: 12px; padding-right: 12px;" class="ivu-col-span-xl-8 ivu-col-span-md-12 ivu-col-span-sm-24">
      <FormItem>
        <div style="float:right">
          <Button type="primary" style="margin-right:1rem" @click="QueryHandleClick">查询</Button>
          <Button style="margin-right:1rem" @click="ResetHandleClick">重置</Button>
        </div>
      </FormItem>
    </Form>
  </div>
</template>

<script>
export default {
  name: 'NonStandardHeader',
  data () {
    return {
      formItem: {
        Customer: '',
        materiel_code: '',
        materiel_name: '',
        material_category: ''
      }
    }
  },
  methods: {
    // 重置点击事件
    ResetHandleClick () {
      this.formItem = {
        Customer: '',
        materiel_code: '',
        materiel_name: '',
        material_category: ''
      }
      this.$emit('ResetHandleClick')
    },
    // 点击查询按钮事件回调
    QueryHandleClick () {
      let check = false
      if (this.formItem.Customer !== '') {
        check = true
      } else if (this.formItem.materiel_code !== '') {
        check = true
      } else if (this.formItem.material_category !== '') {
        check = true
      } else if (this.formItem.materiel_name) {
        check = true
      }
      if (!check) {
        this.$Modal.error({
          title: '请填写需要查询的条件',
          content: '请填写需要查询的条件'
        })
      } else {
        this.$emit('QueryHandleClick', this.formItem)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@media (min-width: 576px) {
  .ivu-col-span-sm-24 {
    display: block;
    width: 100%;
  }
}
@media (min-width: 576px) {
  .ivu-col-span-xl-24 {
    float: left;
    flex: 0 0 auto;
  }
}
@media (min-width: 768px) {
    .ivu-col-span-md-12 {
      display: block;
      width: 50%;
   }
}
@media (min-width: 768px) {
  .ivu-col-span-xl-12 {
    float: left;
    flex: 0 0 auto;
  }
}
@media (min-width: 1200px) {
  .ivu-col-span-xl-8 {
    display: block;
    width: 33.33333333%;
   }
}
@media (min-width: 1200px) {
  .ivu-col-span-xl-8 {
    float: left;
    flex: 0 0 auto;
  }
}
.ivu-row-flex-end {
    justify-content: flex-end;
}
.ivu-row-flex {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}
</style>
